import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './Button.module.css';

/**
 * Ton ve boyut secenekleri OPSIYONEL — 'default' adinda bir uye YOK.
 * Sebep: 'default' bir sure sonra "hangi default?" sorusuna donusuyor; varsayilan
 * davranis bilesenin icinde tek yerde durur, cagri yerinde ton yazilmadiginda ne
 * oldugu belirsiz kalmaz.
 */
export type ButtonTone = 'primary' | 'neutral' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg';

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  tone?: ButtonTone;
  size?: ButtonSize;
  /** Satiri tamamen kaplar — form altlarindaki birincil eylem icin. */
  block?: boolean;
  /** Isleme devam ediyor: tiklama kapali, metin yerinde kalir (zipla yok). */
  loading?: boolean;
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
};

export function Button({
  tone = 'primary',
  size = 'md',
  block = false,
  loading = false,
  iconLeft,
  iconRight,
  className,
  children,
  disabled,
  type,
  ...rest
}: ButtonProps) {
  const classes = [
    styles.button,
    styles[tone],
    styles[size],
    block ? styles.block : undefined,
    loading ? styles.loading : undefined,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      // Form icinde tur belirtilmemis buton "submit" sayilir ve yanlislikla
      // formu gonderir — varsayilani acikca "button" yapiyoruz.
      type={type ?? 'button'}
      className={classes}
      disabled={disabled === true || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {iconLeft ? <span className={styles.icon}>{iconLeft}</span> : null}
      <span className={styles.label}>{children}</span>
      {iconRight ? <span className={styles.icon}>{iconRight}</span> : null}
    </button>
  );
}
